import React from 'react';

import { Box, Grid, Typography } from '@blueprint/ui';
import { useTranslation } from 'react-i18next';

const SingleSelection = ({
    payerReference,
    payerName,
    payerCurrency,
    payerAmount,
    payoutCurrency,
    payoutAmount,
    showFxRate,
    fxRate,
    showPaypalEmail,
    paypalEmail,
    showAddress,
    paymentAddress,
    paymentDetails,
    coolingOffPeriod,
    showBankDetails,
    bankDisplayValue,
}) => {
    const { t } = useTranslation();
    return (
        <Grid container component='dl'>
            <Grid container>
                <Grid xs={6} sm={2} component='dt'>
                    <Box marginTop={2}>
                        <Typography variant='body1'>{t('verifyDetailsConfirm.payer_name')}</Typography>
                    </Box>
                </Grid>
                <Grid item xs={6} component='dd'>
                    <Box marginTop={2} marginLeft='20px'>
                        <Typography variant='body1' id='verify-typo-payername' aria-labelledby='verify-typo-payername-label'>
                            {payerName}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={6} sm={2} component='dt'>
                    <Box marginTop={2}>
                        <Typography variant='body1'>{t('verifyDetailsConfirm.payer_reference')}</Typography>
                    </Box>
                </Grid>
                <Grid item xs={6} component='dd'>
                    <Box marginTop={2} marginLeft='20px'>
                        <Typography variant='body1' id='verify-typo-paymentreference'>
                            {payerReference}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>

            <Grid container>
                <Grid xs={6} sm={2} component='dt'>
                    <Box marginTop={2}>
                        <Typography variant='body1'>{t('verifyDetailsConfirm.payment_details')}</Typography>
                    </Box>
                </Grid>
                <Grid item xs={6} component='dd'>
                    <Box marginTop={2} marginLeft='20px'>
                        <Typography variant='body1' id='verify-typo-paymentDetails'>
                            {paymentDetails}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={6} sm={2} component='dt'>
                    <Box marginTop={2}>
                        <Typography variant='body1'>{t('verifyDetailsConfirm.payer_currency_amount')}</Typography>
                    </Box>
                </Grid>
                <Grid item xs={6} component='dd'>
                    <Box marginTop={2}>
                        <Typography variant='body1' id='verify-typo-payer-currencyamount' marginLeft='20px'>
                            {payerCurrency}
                            &nbsp;
                            {payerAmount}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={6} sm={2} component='dt'>
                    <Box marginTop={2}>
                        <Typography variant='body1'>{t('verifyDetailsConfirm.payout_currency_amount')}</Typography>
                    </Box>
                </Grid>
                <Grid item xs={6} component='dd'>
                    <Box marginTop={2}>
                        <Typography variant='body1' id='verify-typo-payout-currencyamount' marginLeft='20px'>
                            {payoutCurrency}
                            &nbsp;
                            {payoutAmount}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
            {showFxRate ? (
                <Grid container>
                    <Grid item xs={6} sm={2} component='dt'>
                        <Box marginTop={2}>
                            <Typography variant='body1'>{t('verifyDetailsConfirm.rate_used')}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6} component='dd'>
                        <Box marginTop={2}>
                            <Typography variant='body1' id='verify-typo-rateused' marginLeft='20px'>
                                {fxRate}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            ) : null}

            {showBankDetails ? (
                <Grid container>
                    <Grid item xs={6} sm={2} component='dt'>
                        <Box marginTop={2}>
                            <Typography variant='body1'>{t('verifyDetailsConfirm.yourBankAccDetails')}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6} component='dd'>
                        <Box marginTop={2} marginLeft='20px'>
                            <Typography variant='body1' id='verify-typo-bankDetails'>
                                {bankDisplayValue}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            ) : null}
            {showPaypalEmail ? (
                <Grid container>
                    <Grid item xs={6} sm={2} component='dt'>
                        <Box marginTop={2}>
                            <Typography variant='body1'>{t('verifyDetailsConfirm.yourEmailId')}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6} component='dd'>
                        <Box marginTop={2}>
                            <Typography variant='body1' id='verify-typo-paypalEmail' marginLeft='20px'>
                                {paypalEmail}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            ) : null}
            {showAddress ? (
                <Grid container>
                    <Grid item xs={6} sm={2} component='dt'>
                        <Box marginTop={2}>
                            <Typography variant='body1'>{t('verifyDetailsConfirm.yourAddress')}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6} component='dd'>
                        <Box marginTop={2}>
                            <Typography variant='body1' id='verify-typo-address' marginLeft='20px'>
                                {paymentAddress}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            ) : null}
        </Grid>
    );
};

export default SingleSelection;
